import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const PartnersSlider = () => {
  const imagesSlider = [
    { id: 1, src: "./image/ahadu.png" },
    { id: 2, src: "./image/qine.png" },
    { id: 3, src: "./image/SSU copy.png" },
    { id: 4, src: "./image/logo-Sheger.png" },
    { id: 5, src: "./image/FINAL LOGO-01.png" },

    { id: 7, src: "./image/aaor.png" },
    { id: 8, src: "./image/yotor.png" },

    { id: 9, src: "./image/landscape.png" },
  ];
  return (
    <div className="partner-slider-info" data-cue="slideInUp">
      <div className="partner-slider">
        <Swiper
          spaceBetween={25}
          slidesPerView={5}
          speed={1000}
          autoplay={{
            delay: 2000,
          }}
          loop={true}
          modules={[Autoplay]}
        >
          {imagesSlider.map(({ id, link, src }) => {
            return (
              <SwiperSlide key={id}>
                <div className="single-partner-logo">
                  <img src={src} alt={`partner-${id}`} />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default PartnersSlider;
